// @flow
import UserDropdown from './UserDropdown';
export default UserDropdown;



// WEBPACK FOOTER //
// ./src/components/Layout/components/Header/components/UserDropdown/index.js